import React from 'react';
// import { Link } from 'react-router-dom';

import Button from '../UI/button/Button';

// import { db } from '../../config/firebase';

import './VideoLayout.css';

const VideoLayout = () => {

    const keyArray = ["fyO9u9mK3Sc","GsVGnjDyBac"]

    // const [ keyArray, setKeyArray ] = useState([]);

    // useEffect(() => {
    //     db.collection('videos').orderBy('timestamp', 'desc').onSnapshot(snapshot => {
    //       setKeyArray(snapshot.docs.map(doc => ({id: doc.id, videoKey: doc.data()})));
    //     })
    //   }, []);

    return (
        <div className="video">
            <p className="video-title">VIDEOS</p>
            {
                keyArray.map( item => (
                    <React.Fragment>
                        <div className="videoGallery-div" key={item}>
                            <iframe
                                allowfullscreen
                                style={{
                                    width: "100%",
                                    height: "100%"
                                    }}
                                title="video"
                                src={`https://www.youtube.com/embed/${item}`}
                                frameBorder="0"
                            />
                        </div>                    
                    </React.Fragment>

                ))
            }
            {/* <YouTube className="video-player" videoId="XxLgFuPBOLU" opts={opts} onReady={this._onReady} /> */}
            
            <a href="view-videos"><div className="video-btn"><Button color="#ffffff" light={true}>View More</Button></div></a>
        </div>
    );  
};



// _onReady(event) {
//     // access to player in all event handlers via event.target
//     event.target.pauseVideo();
//   }

export default VideoLayout;


// WEBPACK FOOTER //
// ./src/components/videoLayout/VideoLayout.js